import { CACHE_WORKSPACE_KEY } from '@/utils/cache'
import uuidUtil from '@/utils/uuid'
import { navigatePage, PageAlias } from '@/utils/pageRouter'
import { SweepConfig, SweepDestinationType } from '@/services/apis/sweep/models'
import { DestinationTypeEnum } from '@/constants/enum'

export function getPrecison(value: string | number) {
  if (value === null || value === undefined || value === '') {
    return 0
  }
  return value.toString().split('.')[1]?.length || 0
}

/**
 *  版本号格式化
 */
export function formatVersion(version: string): number {
  const split = version.split('.')

  const result = `${split[0]}${split[1]}${split[2].length === 1 ? `${split[2]}0` : split[2]}`
  return Number(result)
}

/**
 *  清除workspaceKey
 */
export function clearCacheWorkspce() {
  localStorage.removeItem(CACHE_WORKSPACE_KEY)
}

/**
 *  token为空时清除登录态
 */
export function checkToken(e: StorageEvent) {
  if (e.key === uuidUtil.UUID_KEY) {
    if (!!e.oldValue && !e.newValue) {
      faultKickOut()
    }
  }
}

// 踢出登录态
export function faultKickOut() {
  uuidUtil.deleteUUID()
  clearCacheWorkspce()
  navigatePage(PageAlias.login)
}

// 获取设备浏览器和系统
type Browser =
  | 'Chrome'
  | 'Safari'
  | '360'
  | 'Edge'
  | 'Firefox'
  | 'QQ'
  | 'Opera'
  | 'Sogou'
  | 'IE'
  | 'Yandex'
  | 'UC'
  | null
export function getBrowser(): Browser {
  const u = window.navigator.userAgent

  if (u.includes('Chrome')) return 'Chrome'

  if (u.includes('Safari') && !u.includes('Chrome')) return 'Safari'
  if (u.includes('360')) return '360'
  if (u.includes('Edge')) return 'Edge'
  if (u.includes('Firefox')) return 'Firefox'
  if (u.includes('QQBrowser')) return 'QQ'
  if (u.includes('Opera')) return 'Opera'
  if (u.includes('Sogou') || u.includes('MetaSr')) return 'Sogou'
  if (u.includes('MSIE') || u.includes('Trident')) return 'IE'
  if (u.includes('YaBrowser')) return 'Yandex'
  if (u.includes('UCBrowser') || u.includes('UBrowser') || u.includes('UCWEB')) return 'UC'
  return null
}
type OSType = 'macOS' | 'Windows' | null
export function getOS(): OSType {
  const u = window.navigator.userAgent
  if (u.includes('Macintosh')) return 'macOS'
  if (u.includes('Windows')) return 'Windows'
  return null
}

export function getWalletTagName(type: SweepDestinationType, t: any) {
  switch (type) {
    case DestinationTypeEnum.VAULT_ACCOUNT:
      return t('wallet.home.assetsType')
    case DestinationTypeEnum.INTERNAL_WALLET:
      return t('record.internalWallet')
    default:
      return ''
  }
}

export function handleSweepI18nTip(t: any, baseConfig: SweepConfig) {
  const text = t('autoSweep.autoSweepWallet')
  return `${text.replace(
    'Deposit Wallet',
    '<span>Deposit Wallet </span>'
  )} <a target="_blank" href=${baseConfig.apiDepositWalletUrl}  > ${t('autoSweep.findApi')}</a>`
}
